import ReviewTerms from './ReviewTerms';
export default ReviewTerms;
